"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketRuleDateTimeOperand = void 0;
const market_rule_operand_1 = require("./market-rule-operand");
class MarketRuleDateTimeOperand extends market_rule_operand_1.MarketRuleOperand {
    /**
     * Constructor
     * @param obj Source object for fields initialiazation
     */
    constructor(obj) {
        super(obj);
        if (obj) {
            this.timeZone = obj.timeZone;
            this.value = obj.value;
        }
    }
}
exports.MarketRuleDateTimeOperand = MarketRuleDateTimeOperand;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFya2V0LXJ1bGUtZGF0ZS10aW1lLW9wZXJhbmQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi8uLi8uLi9zcmMvY29udGVudC9oaXN0b3JpY2FsLXByaWNpbmcvdGltZS1zZXJpZXMvc2VydmljZXMvcnVsZS1lbmdpbmUtc2VydmljZS9jbGFzc2VzL21hcmtldC1ydWxlLWRhdGUtdGltZS1vcGVyYW5kLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLCtEQUEwRDtBQUcxRCxNQUFhLHlCQUEwQixTQUFRLHVDQUFpQjtJQUk1RDs7O09BR0c7SUFDSCxZQUFtQixHQUF3QztRQUN2RCxLQUFLLENBQUMsR0FBRyxDQUFDLENBQUM7UUFFWCxJQUFJLEdBQUcsRUFBRSxDQUFDO1lBQ04sSUFBSSxDQUFDLFFBQVEsR0FBRyxHQUFHLENBQUMsUUFBUyxDQUFDO1lBQzlCLElBQUksQ0FBQyxLQUFLLEdBQUcsR0FBRyxDQUFDLEtBQU0sQ0FBQztRQUM1QixDQUFDO0lBQ0wsQ0FBQztDQUNKO0FBaEJELDhEQWdCQyJ9